<template>
	<section>
		<painel-shell>
			<template v-slot:header-left>
				<user-profile-navigation />
			</template>
			<router-view/>
		</painel-shell>
	</section>

</template>

<script>

import PainelShell from '@/modules/shell/PainelShell'
import UserProfileNavigation from './UserProfileNavigation'
export default {
	components: {
		PainelShell,
		UserProfileNavigation
	},
	methods: {
		routeName () {
			// return route name, converted from camelcase to dash (hyphen)
			return this.$route.name.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserProfile.vue